import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import investorsRoutes from './investors_routes'
import promotersRoutes from './promoters_routes'
import prospectsRoutes from './prospects_routes'
import colaboratorsRoutes from './colaborators_routes'
import contractsRoutes from './contracts_routes'
import attachmentsRoutes from './attachments_routes'
import withdrawsRoutes from './withdraws_routes'
import monthlyCutsRoutes from './monthly_cuts_routes'
import savingsCutsRoutes from './savings_cuts_routes'
import usersRoutes from './users_routes'
import entriesRoutes from './entries_routes'
import tasksRoutes from './tasks_routes'
import configsRoutes from './configs_routes'
import movementsRoutes from './movements_routes'
import store from '@/store/index'

Vue.use(VueRouter)

const authenticate = (to, from, next) => {
  if (store.getters.loggedIn) {
    next()
    return
  }
  next('/login')
}

export default new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', name: 'home', component: Dashboard, beforeEnter: authenticate },
    { path: '/dashboard', name: 'dashboard', component: Dashboard, beforeEnter: authenticate },
    { path: '/login', name: 'login', component: Login, meta: { layout: 'empty' } },
    { path: '/logout',
      beforeEnter (to, from, next) {
        store.commit('logout')
        next('/login')
      }
    }
  ]
    .concat(investorsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(promotersRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(prospectsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(colaboratorsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(contractsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(attachmentsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(withdrawsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(usersRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(entriesRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(tasksRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(monthlyCutsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(savingsCutsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(configsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
    .concat(movementsRoutes.map(route => { return { ...route, ...{ beforeEnter: authenticate } } }))
})



// WEBPACK FOOTER //
// ./src/router/index.js